jQuery(function ($) {
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function(callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function() {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function() {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };
    
    loadValidationScript(function () {
        const headerAuthParent = $("body");

        // HEADER AUTH WINDOW
        headerAuthParent.on("click", ".header-auth-link", function (e) {
            e.preventDefault();
            let currentHeaderAuthLink = $(this);
            currentHeaderAuthLink.toggleClass("header-auth-window-active");
            currentHeaderAuthLink.parents(".header-auth-wrapper").find(".header-auth-window").toggleClass("header-auth-window-hidden");
        });
        // END HEADER AUTH WINDOW

        // HEADER AUTH FORM
        let headerAuthFormRunner = true;

        headerAuthParent.on("submit", ".header-auth-form", function (e) {
            e.preventDefault();

            if (headerAuthFormRunner === true) {
                headerAuthFormRunner = false;

                let headerAuthForm = $(this);
                let headerAuthPreloader = headerAuthForm.find(".header-auth-form-preloader");
                let headerAuthFormInfo = headerAuthForm.serializeArray().reduce(function(obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});

                let warningBoxHeaderAuth = headerAuthForm.find(".header-auth-warning-messages");
                let inputHeaderAuthEmail = headerAuthForm.find(".header-auth-input-warning-email");
                let messageHeaderAuthEmail = headerAuthForm.find(".header-auth-message-warning-email");
                let inputHeaderAuthPassword = headerAuthForm.find(".header-auth-input-warning-password");
                let messageHeaderAuthPassword = headerAuthForm.find(".header-auth-message-warning-password");

                // Show preloader while the form is being processed
                headerAuthPreloader.addClass("preloader-visible");

                // Fetch a fresh CSRF token before submitting
                $.get('/ajax/get-csrf-token', function(tokenData) {
                    // Update CSRF token in helper after fetching
                    if (tokenData.csrf_name && tokenData.csrf_hash) {
                        window.CSRFHelper.setCSRFData(tokenData.csrf_name, tokenData.csrf_hash);
                    }
                    
                    // Inject CSRF token into form data
                    headerAuthFormInfo = window.CSRFHelper.injectCSRF(headerAuthFormInfo);

                    $.ajax({
                        url: "/profile/login", // Update this URL if necessary
                        type: "post",
                        data: headerAuthFormInfo,
                        dataType: 'json',
                        success: function (response) {
                            // Update CSRF token from response (critical for next request)
                            if (response.csrf_name && response.csrf_hash) {
                                window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                            }
                            
                            headerAuthFormRunner = true;
                            headerAuthPreloader.removeClass("preloader-visible");

                            // Reset error states first
                            messageHeaderAuthEmail.hide();
                            messageHeaderAuthPassword.hide();
                            warningBoxHeaderAuth.hide();

                            // If the response is not successful, show error messages
                            if (response.success === false) {
                                let headerAuthFormChecker = 0;

                                // Reset error states
                                inputHeaderAuthEmail.removeClass('is-invalid');
                                inputHeaderAuthPassword.removeClass('is-invalid');
                                messageHeaderAuthEmail.hide();
                                messageHeaderAuthPassword.hide();

                                // Handle different error formats from the controller
                                if (response.errors && typeof response.errors === 'object' && response.errors.email) {
                                    messageHeaderAuthEmail.text(response.errors.email).show();
                                    inputHeaderAuthEmail.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                if (response.errors && typeof response.errors === 'object' && response.errors.password) {
                                    messageHeaderAuthPassword.text(response.errors.password).show();
                                    inputHeaderAuthPassword.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                // Handle general error message (from controller's "message" field)
                                if (headerAuthFormChecker === 0 && response.message) {
                                    // For general errors like "Invalid email or password", show on email field
                                    messageHeaderAuthEmail.text(response.message).show();
                                    inputHeaderAuthEmail.addClass('is-invalid');
                                    inputHeaderAuthPassword.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                if (headerAuthFormChecker > 0) {
                                    warningBoxHeaderAuth.show();
                                }

                            } else {
                                if (response.redirect) {
                                    var email = (headerAuthFormInfo["form-auth-email"] || "").trim();
                                    if (email && window.CarbuyPasskeyLogin && typeof window.CarbuyPasskeyLogin.saveLastEmail === "function") {
                                        window.CarbuyPasskeyLogin.saveLastEmail(email);
                                    } else if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                        try { localStorage.setItem("carbuy_last_login_email", email); } catch (e) {}
                                    }
                                    window.location.href = response.redirect;
                                }
                            }
                        },
                        error: function (xhr) {
                            headerAuthFormRunner = true;
                            headerAuthPreloader.removeClass("preloader-visible");
                            
                            // Try to update CSRF token from error response if available
                            try {
                                const errorResponse = xhr.responseJSON || {};
                                if (errorResponse.csrf_name && errorResponse.csrf_hash) {
                                    window.CSRFHelper.setCSRFData(errorResponse.csrf_name, errorResponse.csrf_hash);
                                }
                            } catch (e) {
                                // Ignore parsing errors
                            }
                            
                            warningBoxHeaderAuth.show().text("Nezināma kļūda. Lūdzu, mēģiniet vēlreiz.");
                        }
                    });
                }).fail(function() {
                    // If CSRF token fetch fails, try to use existing token
                    headerAuthFormInfo = window.CSRFHelper.injectCSRF(headerAuthFormInfo);
                    
                    $.ajax({
                        url: "/profile/login",
                        type: "post",
                        data: headerAuthFormInfo,
                        dataType: 'json',
                        success: function (response) {
                            // Update CSRF token from response
                            if (response.csrf_name && response.csrf_hash) {
                                window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                            }
                            
                            headerAuthFormRunner = true;
                            headerAuthPreloader.removeClass("preloader-visible");

                            // Reset error states first
                            messageHeaderAuthEmail.hide();
                            messageHeaderAuthPassword.hide();
                            warningBoxHeaderAuth.hide();

                            // If the response is not successful, show error messages
                            if (response.success === false) {
                                let headerAuthFormChecker = 0;

                                // Reset error states
                                inputHeaderAuthEmail.removeClass('is-invalid');
                                inputHeaderAuthPassword.removeClass('is-invalid');
                                messageHeaderAuthEmail.hide();
                                messageHeaderAuthPassword.hide();

                                // Handle different error formats from the controller
                                if (response.errors && typeof response.errors === 'object' && response.errors.email) {
                                    messageHeaderAuthEmail.text(response.errors.email).show();
                                    inputHeaderAuthEmail.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                if (response.errors && typeof response.errors === 'object' && response.errors.password) {
                                    messageHeaderAuthPassword.text(response.errors.password).show();
                                    inputHeaderAuthPassword.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                // Handle general error message (from controller's "message" field)
                                if (headerAuthFormChecker === 0 && response.message) {
                                    // For general errors like "Invalid email or password", show on email field
                                    messageHeaderAuthEmail.text(response.message).show();
                                    inputHeaderAuthEmail.addClass('is-invalid');
                                    inputHeaderAuthPassword.addClass('is-invalid');
                                    headerAuthFormChecker++;
                                }

                                if (headerAuthFormChecker > 0) {
                                    warningBoxHeaderAuth.show();
                                }

                            } else {
                                if (response.redirect) {
                                    var email = (headerAuthFormInfo["form-auth-email"] || "").trim();
                                    if (email && window.CarbuyPasskeyLogin && typeof window.CarbuyPasskeyLogin.saveLastEmail === "function") {
                                        window.CarbuyPasskeyLogin.saveLastEmail(email);
                                    } else if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                        try { localStorage.setItem("carbuy_last_login_email", email); } catch (e) {}
                                    }
                                    window.location.href = response.redirect;
                                }
                            }
                        },
                        error: function (xhr) {
                            headerAuthFormRunner = true;
                            headerAuthPreloader.removeClass("preloader-visible");
                            
                            // Try to update CSRF token from error response if available
                            try {
                                const errorResponse = xhr.responseJSON || {};
                                if (errorResponse.csrf_name && errorResponse.csrf_hash) {
                                    window.CSRFHelper.setCSRFData(errorResponse.csrf_name, errorResponse.csrf_hash);
                                }
                            } catch (e) {
                                // Ignore parsing errors
                            }
                            
                            warningBoxHeaderAuth.show().text("Nezināma kļūda. Lūdzu, mēģiniet vēlreiz.");
                        }
                    });
                });
            }
        });



        // END HEADER AUTH FORM

        // HEADER RESET PASSWORD FORM
        let headerResetPasswordFormRunner = true;
        headerAuthParent.on("submit", ".header-reset-password-form", function (e) {
            e.preventDefault();
            if (headerResetPasswordFormRunner === true) {
                headerResetPasswordFormRunner = false;
                let headerResetPasswordForm = $(this);
                let headerResetPasswordPreloader = headerResetPasswordForm.find(".header-reset-password-form-preloader");
                let headerResetPasswordFormInfo = headerResetPasswordForm.serialize();
                let warningBoxHeaderResetPassword = headerResetPasswordForm.find(".header-reset-password-warning-messages");
                let inputHeaderResetPasswordEmail = headerResetPasswordForm.find(".header-reset-password-input-warning-email");
                let messageHeaderResetPasswordEmail = headerResetPasswordForm.find(".header-reset-password-message-warning-email");
                headerResetPasswordPreloader.addClass("preloader-visible");
                // $.ajax({
                //     url: "/wp-admin/admin-ajax.php",
                //     type: "post",
                //     data: {
                //         action: 'headerResetPasswordFormFunc',
                //         headerResetPasswordFormInfo: headerResetPasswordFormInfo
                //     },
                //     dataType: 'json',
                //     success: function (response) {
                headerResetPasswordFormRunner = true;
                let headerResetPasswordFormChecker = 0;
                // let arrayForValidation = [
                //     {
                //         "key": response["form-reset-password-email"],
                //         "path_input": inputHeaderResetPasswordEmail,
                //         "path_message": messageHeaderResetPasswordEmail
                //     },
                // ];
                // for (let i = 0; i < arrayForValidation.length; i++) {
                //     headerResetPasswordFormChecker = checkValidationFrontend(arrayForValidation[i].key, arrayForValidation[i].path_input, arrayForValidation[i].path_message, headerResetPasswordFormChecker);
                // }
                headerResetPasswordPreloader.removeClass("preloader-visible");
                if (headerResetPasswordFormChecker === 0) {
                    headerResetPasswordForm.siblings(".header-reset-password-success-submit").removeClass("d-none");
                    headerResetPasswordForm.remove();
                    warningBoxHeaderResetPassword.hide();
                } else {
                    warningBoxHeaderResetPassword.show();
                }
                // }
                // });
            }
        });
        // END HEADER RESET PASSWORD FORM

        // SWITCH AUTHORIZATION / RESET PASSWORD
        headerAuthParent.on("click", ".header-auth-reset-password-toggle", function (e) {
            e.preventDefault();
            let currentSwitchFormButtonWindow = $(this).parents(".header-auth-window");
            currentSwitchFormButtonWindow.find(".header-auth-form").hide()
            currentSwitchFormButtonWindow.find(".header-reset-password-form").show();
        });
        headerAuthParent.on("click", ".header-back-to-auth-toggle", function (e) {
            e.preventDefault();
            let currentSwitchFormButtonWindow = $(this).parents(".header-auth-window");
            currentSwitchFormButtonWindow.find(".header-auth-form").show()
            currentSwitchFormButtonWindow.find(".header-reset-password-form").hide();
        });
        // END SWITCH AUTHORIZATION / RESET PASSWORD

    });
});